import ReferralInfo from './ReferralInfo';

export default ReferralInfo;
